import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import authInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import { faPaintRoller } from '@fortawesome/free-solid-svg-icons';
import SubmitModal from '../Components/SubmitModal'
import DropdownFlat from '../Components/DropdownFlat'
import swal from 'sweetalert'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    return [day, month, year].join('-');
  }
  
  class ExpeditingApprovedPOAcceptance extends React.Component {

    constructor(props) {
        super(props);
        this.state={     
        text:"",
        headertitle:"",
        comments: "",
        commentsexpeditor:"",
        supplierName: "ABC Tech Inc.",
        modal:false,
        submitmodal:false,
        select: true,
        open: false,
        opacity:"",
        formattedData: [],
        multiCollapseIndex:"",
        dropdowndata: [ {  value: 1,  transporter: "ABC "},
                        {  value: 2,  transporter: "CDE "},
                        {  value: 3,  transporter: "EFG "},
                        ],
         array3:[
            {  value: 1, id:1, DocumentType:"PO",               DocumentName:"PO.pdf",              UploadedOn:"03-03-2020" },
            {  value: 2, id:2, DocumentType:"PO Acceptance",    DocumentName:"POAcceptance.pdf",    UploadedOn:"03-03-2020" },
         ],               
        array2: [
            {  value: 1, id:1, DocumentType:"PO",               DocumentName:"PO.pdf",              UploadedOn:"03-03-2020" },
            {  value: 2, id:2, DocumentType:"PO Acceptance",    DocumentName:"POAcceptance.pdf",    UploadedOn:"03-03-2020" },
            {  value: 3, id:3, DocumentType:"Delivery Schedule",DocumentName:"DeliverySchedule.pdf",UploadedOn:"03-03-2020" },
            {  value: 4, id:4, DocumentType:"Drawing",          DocumentName:"Drawing",             UploadedOn:"03-04-2020" },
            {  value: 5, id:2, DocumentType:"Test Certificate", DocumentName:"Certificate.pdf",     UploadedOn:"03-04-2020" },
            {  value: 6, id:3, DocumentType:"QA Plan",          DocumentName:"Plan.pdf",            UploadedOn:"03-04-2020" },
            
        ]     
          
      }
    //   this.dateformate = this.dateformate.bind(this);
      this.requestmodal= this.requestmodal.bind(this);
    //   this.submitmodal = this.submitmodal(this);
      this.assignmodal= this.assignmodal.bind(this);
      this.savemodal= this.savemodal.bind(this);
      this.togglebutton = this.togglebutton.bind(this); 
      this.modal= this.modal.bind(this);
    }

        savemodal() {
            this.setState({savemodal: !this.state.savemodal });  
            this. setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved successfully. "}) ;
                this. setState({headertitle :"Documents Successfully Approved"}) ;     
            if(this.state.savemodal ==true){
                this.setState(
                {opacity:""}
                )
              }
            else{
                this.setState(
               {opacity:"0.2"} 
                )}}
                
            requestmodal() {
              this.setState({requestmodal: !this.state.requestmodal });  
              this. setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been revised successfully. "}) ;
              this. setState({headertitle :"Documents Revised Successfully"}) ;           
              if(this.state.requestmodal ==true){
                  this.setState(
                    {opacity:""}
                      )}
              else{
                 this.setState(
                 {opacity:"0.2"} 
                 )}}

          assignmodal() {
            this.setState({assignmodal: !this.state.assignmodal }); 
            this. setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved and assigned an engineer successfully. "}) ;
            this. setState({headertitle :"Successfully Assigned an Engineer"}) ;           
            if(this.state.assignmodal ==true){
               this.setState(
                {opacity:""}
                )}
           else{
             this.setState(
            {opacity:"0.2"} 
             )}}

            //  submitmodal() {        
            //     this.setState({submitmodal: !this.state.submitmodal }); 
            //     this.setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been submitted successfully. "}) ;
            //     this.setState({headertitle :"Documents Submitted Successfully "})
            //     if(this.state.submitmodal ==true){
            //        this.setState(
            //         {opacity:""}
            //         )}
            //    else{
            //      this.setState(
            //     {opacity:"0.2"} 
            //      )}}

            // submitmodal(){
            //     swal("Document has been Submitted Successfully!!", { button: false, icon: "info" })
            //   }
            action1() {
                    this.setState({ action1: false });
                    } 

            togglebutton=(Index)=> {       
            var multiCollapseIndex = this.state.multiCollapseIndex 
            if(multiCollapseIndex!=Index || multiCollapseIndex==''){
                this.setState({multiCollapseIndex:Index})
            }}

            toggleSuccessModal(e){        
              this.setState({ modal: !this.state.modal }); 
                if(this.state.modal ==true ){
                  this.setState(
                  {opacity:""}
                   )   
                  }
                else{
                this.setState(
               {opacity:"0.2"} 
                  )                 
                 }             
                  }
                //   toggleSuccessSubmitModal(e){        
                //     this.setState({ submitmodal: !this.state.submitmodal }); 
                //       if(this.state.submitmodal ==true ){
                //         this.setState(
                //         {opacity:""}
                //          )   
                //         }
                //       else{
                //       this.setState(
                //      {opacity:"0.2"} 
                //         )                 
                //        }             
                //         }

            modal() {             
              this.setState({ modal: !this.state.modal });    
                // this.setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been submitted successfully. "}) ;
                // this.setState({headertitle :"Documents Submitted Successfully "})
    
              if(this.state.assignmodal==true){
                this.setState({ assignmodal: !this.state.assignmodal });
              }
            //   if(this.state.submitmodal==true){
            //     this.setState({ submitmodal: !this.state.submitmodal });
            //   }
              if(this.state.savemodal==true){
                this.setState({ savemodal: !this.state.savemodal });     
              }
              if(this.state.requestmodal==true){
                this.setState({ requestmodal: !this.state.requestmodal });
              }          
             if(this.state.modal ==true){                   
                    this.setState(
                    {opacity:""}
                    )
                   }
                else{
                    this.setState(
                       {opacity:"0.2"} 
                    )}
                    }

            handleComments=(e)=>{
                    this.setState({comments: e.target.value})
                    console.log(this.state.comments)
            }

            handleCommentsExpeditor=(e)=>{
                this.setState({comments: e.target.value})
                console.log(this.state.commentsexpeditor)
              }

          
            render()
            {
                var roles = authInstance.getRoles()
                var groups = authInstance.getGroups()
                return(                     
                <div className="Container-fluid pageheight"  >
                
                <div className="Container-fluid p-4" >
               
                   
                {/* --------Success Failure Modal for upload delivery schedule for supplier Start-------------- */}
                <div>
                    <SuccessFailureModal action={this.state.modal} toggleSuccessModal={(e)=>this.toggleSuccessModal(e)}
                     headertitle={this.state.headertitle} text={this.state.text} icon='check-circle' iconcolor="green"   FooterButton="OK" path='/TestModal' />
                </div>
                {/* <div>
                    <SubmitModal action={this.state.submitmodal} toggleSuccessSubmitModal={(e)=>this.toggleSuccessSubmitModal(e)}
                     headertitle={this.state.headertitle} text={this.state.text} icon='check-circle' iconcolor="green"   FooterButton="OK" path='/TestModal' />
                </div> */}
                {/* --------Success Failure Modal End-------------- */}

                {/* APPROVE DOCUMENT MODAL */}
                <Modal isOpen={this.state.savemodal} >
                  <div className={"modal-bg" + (this.state.savemodal === 'false'  ? 'open' : '')}>
                  <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Approve Document </h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.savemodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                 <div >
                <ModalBody Style="modal-body modalbodysWide2">
                     
                 <div className="row ml-2 pt-2 ">
                    Are you sure you want to approve below document?
                        </div>
                   <div className="row ml-2 mt-1 pt-2">
                       <div className="col-md-4"><b>Drawing :</b> drawing.dwg</div> 
                       <div className="col-md-3">
                       <button className="btn2 btn-sms1 mt-2 ml-2 ">View</button>
                       </div>
                   </div>
                   
                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>          
                    </ModalBody>
                    </div>
                    <div>    
                    <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                    <div>
                    <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.savemodal} type="submit">Cancel</button>
                    {/* <Link  to ={{ pathname: '/',state :  { } } }> */}
                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Approve</button>
                    {/* </Link> */}               
                    </div>               
                    </ModalFooter>
                    </div>
                    </div>
                    </Modal>

                {/*  APPROVE DOCUMENT MODAL ENDS */}

                 {/* REQUEST REVISION MODAL*/}
                <Modal isOpen={this.state.requestmodal} >
                  <div className={"modal-bg" + (this.state.requestmodal === 'false'  ? 'open' : '')}>
                  <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Request Revision </h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.requestmodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                 <div >
                <ModalBody Style="modal-body modalbodysWide2">
                     
                 <div className="row ml-2 pt-2 ">
                    Are you sure you want to request a revision of below document?
                        </div>
                   <div className="row ml-2 mt-1 pt-2">
                       <div className="col-md-4"><b>Drawing :</b> drawing.dwg</div> 
                       <div className="col-md-3">
                       <button className="btn2 btn-sms1 mt-2 ml-2 ">View</button>
                       </div>
                   </div>
                   
                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>          
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.requestmodal} type="submit">Cancel</button>
                   {/* <Link  to ={{ pathname: '/',state :  { } } }> */}
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal}type="submit">Request Revision</button>
                {/* </Link> */}               
                </div>
                
                </ModalFooter>
                </div>
                </div>
                </Modal>
                {/* REQUEST REVISION MODAL ENDS */}


                 {/* ASSIGN ENGINEER MODAL */}
                <Modal isOpen={this.state.assignmodal} >
                  <div className={"modal-bg" + (this.state.assignmodal === 'false'  ? 'open' : '')}>
                  <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Approve & Assign Engineer </h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.assignmodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                 <div >
                <ModalBody Style="modal-body modalbodysWide2">
                     
                 <div className="row ml-2 pt-2 mb-3">
                    Are you sure you want to request a revision of below document?
                        </div>
                   <div className="row ml-2 pt-2">
                       <div className="col-md-4"><b>Drawing :</b> drawing.dwg</div> 
                       <div className="col-md-3">
                       <button className="btn2 btn-sms1 mt-2 ml-2 ">View</button>
                       </div>
                   </div>
                   
                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>  
                   <div className="row ml-2 pt-2">
                   <div className="col-md-3"><b>Assign Engineer :</b></div> 
                       <div className="col-md-7">
                       <DropdownFlat defaultopt="Select Option"  data={this.state.dropdowndata} keyObjName={"value"} valueObjName={"transporter"} />
                      </div>               
                   </div>         
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.assignmodal} type="submit">Cancel</button>
                   {/* <Link  to ={{ pathname: '/',state :  { } } }> */}
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Approve and Assign</button>
                {/* </Link> */}               
                </div>            
                </ModalFooter>
                </div>
                </div>
                </Modal>
                 {/* ASSIGN ENGINEER MODAL ENDS */}

                <div className="row " >
                    {roles[5]?<>
                        <div className="col-md-12 pb-2  ">
                        
                            <Link  to ={{ pathname: '',state : { }}}> 
                            <div><button className="btn2 btn-sms1 mt-2 float-right mr-4 " type="submit"  >Save</button></div>
                            </Link>
                            <Link  to ={{ pathname: '',state : { }}}> 
                            <div><button className="btn2 btn-sms1 mt-2 float-right mr-4 " type="submit" onclick={this.submitmodal} >Submit</button></div>
                            </Link>
                     </div></>
                     :roles[7]?<>                
                        <div className="col">
                        <Link  to ={{ pathname: '',state : { }}}> 
                        <div><button className="btn2 btn-sms1 mt-2 float-right mr-4 " >Save</button></div>
                        </Link>
                        
                        
                        </div>
                     </>
                     :<></>
                     }
                </div>
                <div className="row-md-12" >
               
                    <div>
                        <div className="row ">
                            <div className="col pt-2 " >
                                <div className="row">
                                    <div className="col-md-4 " ><b>PO No:</b></div>
                                    <div className="col">4700026643</div>
                                </div>

                            </div>
                            <div className="col">
                                <div className="row">
                                    <div className="col-md-4 " ><b>PO Date:</b></div>
                                    <div className="col ">15-06-2020</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col-md-4 " ><b>PO Amount:</b></div>
                                    <div className="col">2800</div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 " ><b>Supplier Name:</b></div>
                                    <div className="col ">ABC Metallics</div>
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col-md-4 " ><b>Location:</b></div>
                                    <div className="col">Gurgaon</div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 " ><b>Payment Term:</b></div>
                                    <div className="col ">Y001</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 pt-2 " >
                                <div className="row">
                                    <div className="col-md-6 " ><b>PO Document:</b></div>
                                    <div className="col">
                                        {/* <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.poDetails.poDetailsDocumentId + "/download"} target="_blank" download> */}
                                            <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="2x" />
                                        {/* </a>  */}
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6" ><b>PO Acceptance Document:</b></div>
                                    <div className="col">
                                         {/* <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.poDetails.poAcceptanceDocumentId + "/download"} target="_blank" download> */}
                                             <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="2x" />
                                        {/* </a>  */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row mt-2">
                                    <div className="col" ><b>Delivery Schedule Documents:</b></div>
                                    <div className="col">
                                         {/* <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.poDetails.poAcceptanceDocumentId + "/download"} target="_blank" download> */}
                                             <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="2x" />
                                        {/* </a>  */}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
               
                </div>
                
              <div className="row-md-8 pr-4 pt-4">
              <div ><h4>All Documents:</h4></div>
                <div className="col ">
                
                    <div className="row  headerbar ">
                   
                          
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Document Type</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Document Name</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar ">Uploaded On</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">Actions</div>
                           
                    </div>
                        {this.state.array2.map((element,Index)=>
                        
                            <div className={Index%2==0? 'row border ':'row  background '} 
                             onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                          
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">{element.DocumentType}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">{element.DocumentName}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign  ">{dateFormater(element.UploadedOn)}</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign  ">
                            {element.DocumentType=="Drawing"||element.DocumentType=="Test Certificate"||element.DocumentType=="QA Plan"?
                                <>
                                    {roles[5]?<>
                                        <Link  to ={{ pathname: '',state : {} }}> 
                                            <FontAwesomeIcon icon={"upload"}  color="black" title="View" size="lg" />
                                        </Link> </>
                                        :
                                        // for expeditor team approve reject and view
                                     roles[7]?
                                        <>
                                            <button className="btn2 btn-sms1 rounded  float-right " onClick={this.requestmodal}>Revise</button>
                                            <button className=" btn2 btn-sms2 rounded  float-right "onClick={this.savemodal}>Approve</button>
                                            <Link  to ={{ pathname: '',state : {} }}> 
                                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                            </Link> 
                                        </>
                                        :
                                        // for tpm :after Expediting team approve the documents the drawing documents should be approved by team
                                        (roles[12] && element.DocumentType=="Drawing")?
                                        <>
                                            <button className="btn2 btn-sms1 rounded  float-right" onClick={this.requestmodal}>Revise</button>
                                            <button className=" btn2 btn-sms2 rounded  float-right "onClick={this.assignmodal}>Approve</button>
                                           <Link  to ={{ pathname: '',state : {} }}> 
                                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                            </Link> 
                                        </>
                                        :
                                        // FOR ENGINEERING TEAM APPROVE THE DOCUMENT THAT HAS BEEN APPROVED BY THE TPM
                                        (roles[17] && element.DocumentType=="Drawing")?
                                        <>
                                            <button className="btn2 btn-sms1 rounded  float-right " onClick={this.requestmodal}>Revise</button>
                                            <button className=" btn2 btn-sms2 rounded  float-right " onClick={this.savemodal}>Approve</button>
                                           <Link  to ={{ pathname: '',state : {} }}> 
                                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                            </Link> 
                                        </>
                                        :

                                        // FOR DESIGN TEAM APPROVE THE DOCUMENT THAT HAS BEEN APPROVED BY THE ENGINEERING    
                                        (roles[18] && element.DocumentType=="Drawing")?
                                        <>
                                            <button className="btn2 btn-sms1 rounded  float-right " onClick={this.requestmodal}>Revise</button>
                                            <button className=" btn2 btn-sms2 rounded  float-right " onClick={this.savemodal}>Approve</button>
                                           <Link  to ={{ pathname: '',state : {} }}> 
                                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                            </Link> 
                                        </>
                                        :
                                        <>
                                           <Link  to ={{ pathname: '',state : {} }}> 
                                                <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                            </Link> 
                                        </>
                                    }
                                </>
                            :
                                <><Link  to ={{ pathname: '',state : {} }}> 
                                    <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                </Link> </>
                        }
                            
                            </div>
                                      
                         <div className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                                  <form>
                                        <div></div>
                                           <div className="row">
                                              <div className="col-md-3">
                                                  <b>Comments: </b>
                                               </div>
                                               <div className="col">
                                                   ABC
                                                {/* {element.WBSNo} */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                        <b>Commented By: </b>
                                                    </div>
                                                    <div className="col">
                                                        ABC
                                                        {/* {element.Location} */}
                                                    </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-3">
                                                  <b>Commented On </b>
                                                </div>
                                                <div className="col">
                                                    16-05-2020
                                                {/* {dateFormater(element.PoDate)} */}
                                                </div>
                                            </div>                                             
                                   </form> 
                             </div>
                          </div>
                    )}  
                        <br/> 
                        <br/>                     
                  </div>
            </div>
        </div>
      </div>
    )
  }
}

export default ExpeditingApprovedPOAcceptance;